export default {
      id: "btn_equal-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite.svg#btn_equal",
      toString: function () {
        return this.url;
      }
    }